import LinkedList from "dbly-linked-list";

const RoutesToDblyLinkedList = (routesArray) => {
  const routes = new LinkedList();
  routesArray.forEach((route) => {
    routes.insert(route);
  });
  return routes;
};

const RouteOrder = {
  "/": 0,
  "/projects": 1,
  "/experience": 2,
  "/blog": 3
};

const ROUTES = {
  PROJECT: "project",
  EXPERIENCE: "experience",
  BLOG: "blog"
}

const HOSTNAME = "antrikshmisri.netlify.app";

export default RoutesToDblyLinkedList;
export { RouteOrder, HOSTNAME, ROUTES };
